import React, { Component } from "react";
import { getBrowserLocale } from "../Utils/SupportUtils";

class Card extends Component {
  state = {
    hovered: false,
  };

  mouseEnter = () => {
    this.setState({
      hovered: true,
    });
  };

  mouseLeave = () => {
    this.setState({
      hovered: false,
    });
  };

  render() {
    const {
      className,
      node,
      iconStyle,
      bodyStyle,
      selectHandler,
      contactOption,
    } = this.props;
    const { hovered } = this.state;

    const language = getBrowserLocale();

    const style = iconStyle
      ? {
          card: {
            border: `1px solid ${iconStyle.borderColor}`,
            borderRadius: "0.25rem",
            padding: "10px",
            textAlign: "center",
            backgroundColor: iconStyle.backgroundColor
              ? iconStyle.backgroundColor
              : "initial",
            cursor: "pointer",
          },
          icon: {
            color: hovered ? iconStyle.hoverColor : iconStyle.color,
          },
        }
      : {};

    return (
      <div
        className={`${className || ""} card`}
        style={style.card}
        onClick={() => selectHandler(node)}
      >
        <span onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
          {node.imgname && (
            <i className={`${node.imgname} fa-6x m-2`} style={style.icon}></i>
          )}
        </span>

        <div
          style={{
            margin: node.imgname ? "10px" : "initial",
            color: bodyStyle ? bodyStyle.color : "initial",
          }}
        >
          <b>{contactOption ? node.text : node.label[language]}</b>
        </div>
      </div>
    );
  }
}

export default Card;
